import { createAction, props } from '@ngrx/store';
import { IUserRoleRequest, IUserRoleResponse } from '../models/user-role.model';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';

export const loadUserRolesRequest = createAction('[UserRole] Load UserRoles Request', props<{ request: IUserRoleRequest }>());

export const loadUserRolesResponse = createAction('[UserRole] Load UserRoles Response', props<{ response: IUserRoleResponse }>());

export const loadUserRolesFailure = createAction('[UserRole] Load UserRoles Failure', props<{ error: IGenericError<ErrorResponse> }>());
